import * as React from "react";
import Card from "@mui/material/Card";
import { Avatar, CardActionArea, useMediaQuery } from "@mui/material";
import { Container, Row, Col } from "react-bootstrap";
import CardContent from "@mui/material/CardContent";
import { Typography } from "@mui/material";
import style from "./PRTPTeacher.module.css";
import AOS from "aos";
import "aos/dist/aos.css";
import amir from "../../../assets/prtp/Trainers/Amir.png";
import amzad from "../../../assets/prtp/Trainers/Professor_Mohammad_Amzad_Hossain.png";
import jahangir from "../../../assets/prtp/Trainers/Dr.Mohammad_Jahangir_Alam.png";
import lutfor from "../../../assets/prtp/Trainers/Lutfor.png";
import nasim from "../../../assets/prtp/Trainers/Nasim.png";
import shariful from "../../../assets/prtp/Trainers/Shariful.png";
import mahmudul from "../../../assets/prtp/Trainers/Dr. Md.Mahmudul_Hassan.png";
import tareq from "../../../assets/prtp/Trainers/tareq.png";
import saifuddin from "../../../assets/prtp/Trainers/Saifuddin.png";
import ranjan from "../../../assets/prtp/Trainers/Dr.ranjan.png";
import Image from "next/image";

export default function PRTPTeacher() {
  React.useEffect(() => {
    AOS.init();
  }, []);

  const matches = useMediaQuery("(max-width:768px)");

  return (
    <Container>
      <Typography
        align="center"
        className="py-3"
        fontWeight={600}
        variant={matches ? "h5" : "h4"}
        gutterBottom
      >
        Course Teachers of <span className="text-primary">PRTP</span>
      </Typography>

      <Row
        className={`${style.bg_img} py-5 g-4 justify-content-center`}
        xs={1}
        sm={2}
        md={2}
        xl={3}
      >
        {itemData.map((item, idx) => (
          <Col key={idx} data-aos="zoom-in">
            <Card className={`${style.zoom} rounded-4`}>
              <CardActionArea className="d-flex flex-column py-3">
                <Image
                  className="border rounded-pill"
                  width={118}
                  height={118}
                  src={item.img.src}
                  alt={item.name}
                  priority
                />

                <CardContent align="center" className={`${style.cardContent}`}>
                  <Typography
                    gutterBottom
                    fontWeight={600}
                    variant="subtitle1"
                    component="div"
                  >
                    {item.name}
                  </Typography>
                  <Typography variant="body2" color="text.primary">
                    {item.designation} <br />
                    {item.university}
                  </Typography>
                  <Typography variant="body2 " color="text.primary">
                    {item.title}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

const itemData = [
  {
    img: amir,
    name: "Dr. Md. Amir Hussain",
    designation: "Professor, Economics",
    university: "Jahangirnagar University",
  },
  {
    img: amzad,
    name: "Mohammad Amzad Hossain",
    designation: "Professor, Economics",
    university: "Jahangirnagar University",
  },
  {
    img: jahangir,
    name: "Dr. Mohammad Jahangir Alam",
    designation: "Professor, Economics",
    university: "Jahangirnagar University",
  },
  {
    img: lutfor,
    name: "Mohammad Lutfor Rahman",
    designation: "Associate Professor, Economics",
    university: "Jahangirnagar University",
  },

  {
    img: ranjan,
    name: "Dr. Ranjan Saha Partha",
    designation: "Professor, Department of Anthropology",
    university: "Jahangirnagar University",
  },

  {
    img: nasim,
    name: "S.M.Nasim Azad",
    designation: "Assistant Professor, Statistics",
    university:
      "Bangabandhu Sheikh Mujibur Rahman Science and Technology University",
  },

  {
    img: shariful,
    name: "Dr. Md. Shariful Islam",
    designation: "Associate Professor, Economics",
    university: "Bangladesh University of Professionals (BUP)",
  },

  {
    img: mahmudul,
    name: "Dr. Md. Mahmudul Hassan",
    designation: "Associate Professor, Economics",
    university: "Bangladesh University of Business and Technology (BUBT)",
  },

  {
    img: tareq,
    name: "Tareq Imam Zahid",
    designation: "Assistant Professor, Economics",
    university: "Bangladesh University of Business and Technology (BUBT)",
  },

  {
    img: saifuddin,
    name: "Mohammad Saifuddin",
    designation: "Assistant Professor, Statistics",
    university: "Bangladesh University of Business and Technology (BUBT)",
  },
];
